var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothAnatomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 0,
    height: 0,
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "tooth-incisor",
    viewBox: "0 0 44 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 4 L 36 4 L 38 14 L 38 38 L 34 44 L 10 44 L 6 38 L 6 14 Z",
    fill: "var(--tooth-fill, currentColor)",
    fillOpacity: "var(--tooth-fill-opacity, 0.18)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.95,
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-surface": "B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "M"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "O"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 18,
    height: 18,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "L"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 14 44 L 22 58 L 30 44 Z",
    fill: "var(--tooth-root-fill, currentColor)",
    fillOpacity: "var(--tooth-root-fill-opacity, 0.25)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.85,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tooth-canine",
    viewBox: "0 0 44 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 3 L 36 9 L 38 18 L 38 38 L 34 44 L 10 44 L 6 38 L 6 18 L 8 9 Z",
    fill: "var(--tooth-fill, currentColor)",
    fillOpacity: "var(--tooth-fill-opacity, 0.18)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.95,
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-surface": "B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "M"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "O"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 18,
    height: 18,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "L"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 12 44 L 22 59 L 32 44 Z",
    fill: "var(--tooth-root-fill, currentColor)",
    fillOpacity: "var(--tooth-root-fill-opacity, 0.25)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.85,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tooth-premolar",
    viewBox: "0 0 44 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 4 L 22 7 L 30 4 L 38 12 L 38 38 L 34 44 L 10 44 L 6 38 L 6 12 Z",
    fill: "var(--tooth-fill, currentColor)",
    fillOpacity: "var(--tooth-fill-opacity, 0.18)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.95,
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-surface": "B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "M"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "O"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 18,
    height: 18,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 17,
    x2: 22,
    y2: 31,
    stroke: "currentColor",
    strokeOpacity: 0.25,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "L"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 13 44 L 18 58 L 22 50 L 26 58 L 31 44 Z",
    fill: "var(--tooth-root-fill, currentColor)",
    fillOpacity: "var(--tooth-root-fill-opacity, 0.25)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.85,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tooth-molar",
    viewBox: "0 0 44 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 5 L 16 7 L 22 5 L 28 7 L 34 5 L 39 12 L 39 38 L 34 44 L 10 44 L 5 38 L 5 12 Z",
    fill: "var(--tooth-fill, currentColor)",
    fillOpacity: "var(--tooth-fill-opacity, 0.18)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.95,
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-surface": "B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "M"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "O"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 18,
    height: 18,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 24,
    x2: 30.5,
    y2: 24,
    stroke: "currentColor",
    strokeOpacity: 0.25,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 15.5,
    x2: 22,
    y2: 32.5,
    stroke: "currentColor",
    strokeOpacity: 0.25,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 6,
    height: 18,
    rx: 1.2,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-surface": "L"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 26,
    height: 9,
    rx: 1.5,
    fill: "currentColor",
    fillOpacity: 0,
    stroke: "currentColor",
    strokeOpacity: 0.18,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11 44 L 14 58 L 18 50 L 22 58 L 26 50 L 30 58 L 33 44 Z",
    fill: "var(--tooth-root-fill, currentColor)",
    fillOpacity: "var(--tooth-root-fill-opacity, 0.25)",
    stroke: "var(--tooth-stroke, currentColor)",
    strokeOpacity: 0.85,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothAnatomy);
export default __webpack_public_path__ + "static/media/tooth-anatomy.56967ff76f10597f798e3c6f936b561f.svg";
export { ForwardRef as ReactComponent };